/**
 * @packageDocumentation
 * @module api.functional.users.invite
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { InviteUserDto } from "../../../structures/InviteUserDto";
import type { ServiceResponse__object } from "../../../structures/ServiceResponse__object";

/**
 * @controller UserController.inviteUser
 * @path POST /users/invite/:email
 * @accessor api.functional.users.invite.inviteUser
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function inviteUser(
  connection: IConnection,
  email: string,
  body: inviteUser.Body,
): Promise<inviteUser.Output> {
  return PlainFetcher.fetch(
    {
      ...connection,
      headers: {
        ...connection.headers,
        "Content-Type": "application/json",
      },
    },
    {
      ...inviteUser.METADATA,
      template: inviteUser.METADATA.path,
      path: inviteUser.path(email),
    },
    body,
  );
}
export namespace inviteUser {
  export type Body = InviteUserDto;
  export type Output = ServiceResponse__object;

  export const METADATA = {
    method: "POST",
    path: "/users/invite/:email",
    request: {
      type: "application/json",
      encrypted: false,
    },
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 201,
  } as const;

  export const path = (email: string) =>
    `/users/invite/${encodeURIComponent(email?.toString() ?? "null")}`;
}
